// extracted by mini-css-extract-plugin
export default {"map-container-mobile":"map-container-mobile_aOMIwf9N"};